import * as angular from 'angular';
import * as _ from 'lodash';

import { ComponentDefinition, Application, Pattern, DisplayObject } from '../../models';
import { IApplicationService, IApplicationFilteringService } from '../../services';
import { noneApplication, guidEmpty } from '../../common';

class ApplicationSelectorController implements angular.IComponentController {
    isLoading: boolean = false;
    loadingMessage: string;

    applications: Application[];
    filtered: Application[];
    isPopoverOpen: boolean;
    startOpen: boolean;
    formController: angular.IFormController;
    model: string;
    placeholder: string;
    placement: string;
    property: string;
    isRequired: boolean;
    contextClass: string;
    isDisabled: boolean;
    excludedGuidList: string[];

    // For research
    selectedItem: string;
    criteria: Pattern<DisplayObject>[];
    searchString: string;
    searchResults: Application[] = [];

    onChange: () => void;

    static $inject = ['$scope', '$timeout', 'applicationService', 'applicationFilteringService'];

    constructor(private _$scope: angular.IScope,
        private _$timeout: angular.ITimeoutService,
        private _applicationService: IApplicationService,
        private _applicationFilteringService: IApplicationFilteringService) {
        this.criteria = [
            {
                label: 'Name',
                isMatch: () => true,
                model: 'a',
                placeholder: 'Application name',
                property: 'a'
            }];
    }

    $onInit() {
        if (this.isRequired === undefined) {
            this.isRequired = false;
        }
        if (!this.placeholder) {
            this.placeholder = 'Click to select an application';
        }

        this._$scope.$watch(() => this.selectedItem, (newValue: string) => {
            if (newValue) {
                if (this.formController && newValue !== this.model) {
                    this.model = newValue;
                    this.isPopoverOpen = false;
                    this.formController.$setDirty();
                    if (this.onChange) {
                        this._$timeout(() => {
                            this.onChange();
                        });
                    }
                }
            }
        });

        this._$scope.$watch(() => this.searchString, (newValue) => {
            this.search();
        });

        if (this.startOpen) {
            this._$timeout(() => {
                this.refresh();
                this.isPopoverOpen = true;
            });
        }

        this.refresh();
    }

    $onChanges(changesObj: angular.IOnChangesObject) {
        if (changesObj.hasOwnProperty('isDisabled')) {
            const isDisabled = changesObj['isDisabled'];
            if (isDisabled.currentValue) {
                this.selectedItem = null;
            }
        }
    }

    private search(): void {
        this.searchResults = this._applicationFilteringService.filter(this.searchString);
    }

    refresh(): void {
        this._applicationService
            .getAll(data => {
                this.applications = data.map(d => d.application);
                this.filtered = this.applications;

                // Remove current application
                if (this.excludedGuidList && this.excludedGuidList.length > 0) {
                    this.filtered = this.applications.filter(app => this.excludedGuidList.indexOf(app.guid) < 0);
                }

                // Remove currently selected application
                if (this.model) {
                    this.filtered = this.filtered.filter(app => app.guid !== this.model);
                }

                // Remove applications that are already children
                this.filtered = this.filtered.filter(app => !app.parentApplicationGuid || app.parentApplicationGuid === guidEmpty);

                //Add None application
                this.filtered = [noneApplication].concat(this.filtered);

                // Initialize application filtering service
                this._applicationFilteringService.applications(this.filtered);

                // Initial search
                if (!this.searchString && this.filtered && this.filtered.length > 0) {
                    this.searchString = '*';
                    this.search();
                }
            });
    }

    closePopover(): void {
        this.isPopoverOpen = false;
    }

    displayName(): string {
        let name = '';
        if (!this.model && this.model === guidEmpty) {
            name = '';
        } else {
            const application = this.applications?.find(a => a.guid === this.model);
            if (application) {
                name = application.name;
            }
        }
        return name;
    }
}

export const wtApplicationSelector: ComponentDefinition = {
    componentId: 'wtApplicationSelector',
    controller: ApplicationSelectorController,
    template: require('./applicationSelector.component.html'),
    controllerAs: 'vm',
    bindings: {
        formController: '<',
        application: '=?',
        model: '=',
        placeholder: '@?',
        placement: '@?',
        property: '<?',
        isRequired: '<?',
        onChange: '&?',
        contextClass: '@?',
        isDisabled: '<?',
        excludedGuidList: '<?'
    }
};
